import { type FooterData } from './types';

export const footerData: FooterData = {
  contact: {
    phone: '+7 (499) 130-48-45',
    email: 'info@ru.dreametech.com',
    techEmail: 'dreamesupport@dreame.tech'
  },
  podcast: {
    title: 'Следите за нами в соцсетях',
    socials: [
      {
        link: '#',
        icon: 'vk',
        text: 'Вконтакте'
      },
      {
        link: '#',
        icon: 'telegram',
        text: 'Telegram канал'
      }
    ]
  },
  links: [],
  copyright: {
    text: ['© 2026 Политика обработки данных.']
  }
};
